import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchEditablePayments'
})
export class SearchEditablePaymentsPipe implements PipeTransform {

  transform(transactions: any, searchText: string) {
    if (!searchText) {
      return transactions; // Return the original array if search text is empty
    }

    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison

    return transactions.filter((transaction: any) =>
    (transaction.chassis_no && transaction.chassis_no.toLowerCase().includes(searchText)) ||
    (transaction.bl_no && transaction.bl_no.toLowerCase().includes(searchText))
    );
  }
}
